import { Permission } from '@server/permissions';
import { useSelector } from 'react-redux';
import { selectDefaultCreationCrmOrgId } from '../../../reducers/userInfoReducer';
import { usePermissions } from './usePermissions';

export const useCheckAllPermissionsForCurrentCrmOrg = (permissionArray: Permission[]) => {
  const { checkAllPermissionsForOrg } = usePermissions();
  const crmOrgId = useSelector(selectDefaultCreationCrmOrgId);

  return checkAllPermissionsForOrg(permissionArray, crmOrgId ?? '');
};
